import React from 'react'
import PropTypes from 'prop-types'
import { Pane, Text } from 'evergreen-ui'

const SearchResultTitle = ({ title, subtitle }) => (
  <Pane display="flex" flexDirection="column" flex="1" minWidth={0}>
    <Text
      fontWeight={500}
      whiteSpace="nowrap"
      overflow="hidden"
      textOverflow="ellipsis"
      size={300}
    >
      {title}
    </Text>

    {subtitle && (
      <Text
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
        fontSize={10}
        color="muted"
      >
        {subtitle}
      </Text>
    )}
  </Pane>
)

SearchResultTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string
}

export default SearchResultTitle
